module.exports = __webpack_public_path__ + "static/kartchen_mobi-8b09658d0d0a14c204c69201909b4908.png";